namespace TabAurous.Common {
    export enum CostMethod {
        Fixed = 9,
        Attributes = 10,
        BOM = 11
    }
    Serenity.Decorators.registerEnumType(CostMethod, 'TabAurous.Common.CostMethod', 'Cost.Method');
}
